"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseQueryCommand = exports.BaseAPI = void 0;
class BaseAPI {
    constructor(lcd) {
        this.lcd = lcd;
    }
    get execute() {
        this._execute = this._execute || this.commandActivator(this.executeType);
        return this._execute;
    }
    get query() {
        this._query = this._query || this.commandActivator(this.queryType);
        return this._query;
    }
    commandActivator(Type) {
        return new Type(this.lcd);
    }
}
exports.BaseAPI = BaseAPI;
class BaseQueryCommand {
    constructor(lcd) {
        this.lcd = lcd;
    }
}
exports.BaseQueryCommand = BaseQueryCommand;
